module.exports = __webpack_public_path__ + "static/img/apply4.08327631.png";